// Mirror of the server-side NAV whitelist. The chat assistant will only ever
// execute a `navigate` action whose route appears in this list; anything else
// is dropped silently. Keep in sync with server/lib/catalog.js NAV_WHITELIST.
import { productsData } from '../data/products'

export const NAV_WHITELIST = [
  '/',
  '/products',
  '/products/ppr_water',
  '/products/pe_water',
  '/products/pvc_u_water',
  '/products/pvc_u_drainage',
  '/products/pvc_conduit',
  '/products/ppr_household',
  '/about',
  '/bases',
  '/quality',
  '/news',
  '/contact',
  '/quote'
]

// Static routes → existing i18n nav keys, so the "Taking you to …" line reads
// naturally in every locale.
const ROUTE_LABEL_KEYS = {
  '/': 'navHome',
  '/products': 'navProducts',
  '/about': 'navAbout',
  '/bases': 'navBases',
  '/quality': 'navQuality',
  '/news': 'navNews',
  '/contact': 'navContact',
  '/quote': 'navCTA'
}

export function isAllowedRoute(route) {
  return typeof route === 'string' && NAV_WHITELIST.includes(route)
}

// Human label for a whitelisted route in the current locale. Product detail
// routes resolve to the localized product name; static routes to their nav key.
export function routeLabel(route, t, locale) {
  if (ROUTE_LABEL_KEYS[route]) return t(ROUTE_LABEL_KEYS[route])
  const m = /^\/products\/(.+)$/.exec(route || '')
  if (m) {
    const p = productsData.find((pr) => pr.id === m[1])
    if (p) return p.name[locale] || p.name.en || route
  }
  return route
}
